import React from 'react'
import {Player} from 'video-react'
import 'video-react/dist/video-react.css'
import {Modal, Button} from 'antd'
import Mask from '@/components/mask'
import styles from './index.module.scss'
import img from './_img/img.png'
import Layout from './layout'
import VideoModal from './video'
import ImgModal from './img'
// import ImageGallery from 'react-image-gallery';
import ImageGallery from '@/components/gallery/ImageGallery.js'
import {
    ArrowLeftOutlined
  } from '@ant-design/icons';

import Swiper from '@/components/swiper'
import NumLight from '@/components/num-light'
import FaceClick from './faceClick'

import SwipeScan from '@/components/swip-scan'

import swiperImg1 from '@/files/modal/swiper/re-vital-1.jpg'
import swiperImg2 from '@/files/modal/swiper/re-vital-2.jpg'
import swiperImg3 from '@/files/modal/swiper/re-vital-3.jpg'

import {getContent} from '@/common/modal_content.js'

export default class DetailModal extends React.PureComponent {
    state = {
        upLight: true,
        downLight: false,
        updownLightClick: false,
        videoShow: false,
        imgShow: false,
        imgIconShow: false,
        videoSrc: '',
        // imgSrc: '',
        imgSizes: '',
        imglistContent: <></>,
        imgShopUrl: '',
    }

    swiperList = [
        {url: swiperImg1},
        {url: swiperImg2},
        {url: swiperImg3}
    ]

    openVideo = (src) => {
        this.setState({
            videoShow: true,
            videoSrc: src
        })
        this.props.toggleAudioPlay(false)
        this.props.changeVedioBackground(true)
    }

    closeVideo = () => {
        this.setState({
            videoShow: false
        })
        this.props.toggleAudioPlay(true)
        this.props.changeVedioBackground(false)
    }

    openImg = (src, sizes) => {
        this.setState({
            imgShow: true,
            imgSrc: src,
            imgSizes: sizes
        })
    }

    closeImg = () => {
        this.setState({
            imgShow: false,
            imgSrc: '',
            imgSizes: []
        })
    }


    clickUpHandle = () => {
        this.setState({
            upLight: true,
            downLight: false,
        })
    }

    updownLightClickHandle = () => {
        this.setState({
            updownLightClick: true
        })
    }

    clickDownHandle = () => {
        this.setState({
            upLight: false,
            downLight: true,
        })
    }

    clickToShopOrg() {
        window.open('https://cemoy.com/shop')
        // window.location.href = 'https://cemoy.com/shop/products/product_cat-the-lumen-series/'
    }

    render() {
        const {videoShow, videoSrc, imgShow, imgSrc, imgSizes} = this.state
        const {modalVisible, onCancel, modalType, language} = this.props
        return (
            <>
                <div>

                </div>
                <Modal
                    visible={modalVisible}
                    className={styles.modal}
                    wrapClassName={styles.cont}
                    footer={null}
                    onCancel={onCancel}
                    closable={false}
                    maskStyle={{
                        background: 'none',
                    }}
                >
                    {/* 关闭按钮 */}
                    <div className={styles.close} onClick={onCancel}>
                        {/* <i className='iconfont icon-back'
                           style={{fontSize: '12px', width: '15px', transform: 'scale(.8)'}} alt=''></i>&nbsp;&nbsp; */}
                        <ArrowLeftOutlined style={{fontSize: '7px'}}/>
                        {getContent(language, 'modal_back_btn')}
                    </div>

                    <div className={styles.content}>

                        {/* modal_s3_w1_img */}
                        {modalType === 'modal_s3_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s3_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s3_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s3_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s3_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s3_w1_img_img_big'),
                                                    getContent('en', 'modal_s3_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s3_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s4_w1_img */}
                        {modalType === 'modal_s4_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s4_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s4_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s4_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s4_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s4_w1_img_img_big'),
                                                    getContent('en', 'modal_s4_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s4_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s5_w1_img */}
                        {modalType === 'modal_s5_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s5_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s5_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s5_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s5_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s5_w1_img_img_big'),
                                                    getContent('en', 'modal_s5_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s5_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s6_w1_img */}
                        {modalType === 'modal_s6_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s6_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s6_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s6_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s6_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                console.log('test onclick')
                                                this.openImg(getContent(language, 'modal_s6_w1_img_img_big'),
                                                    getContent('en', 'modal_s6_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s6_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s7_w1_img */}
                        {modalType === 'modal_s7_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s7_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s7_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s7_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s7_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s7_w1_img_img_big'),
                                                    getContent('en', 'modal_s7_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s7_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s9_w1_img */}
                        {modalType === 'modal_s9_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s9_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s9_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s9_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s9_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s9_w1_img_img_big'),
                                                    getContent('en', 'modal_s9_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s9_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s10_w1_img */}
                        {modalType === 'modal_s10_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s10_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s10_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s10_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s10_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s10_w1_img_img_big'),
                                                    getContent('en', 'modal_s10_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s10_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s12_w1_img */}
                        {modalType === 'modal_s12_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s12_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s12_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s12_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s12_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s12_w1_img_img_big'),
                                                    getContent('en', 'modal_s10_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s12_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s13_w1_img */}
                        {modalType === 'modal_s13_w1_img' && (
                            <Layout
                                title={<p>{getContent(language, 'modal_s13_w1_img_title')}</p>}
                                titleTips={getContent(language, 'modal_s13_w1_img_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'modal_s13_w1_img_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'modal_s13_w1_img_img')}
                                            className={styles.img} alt=""
                                        />
                                        <img
                                            name='imgShowIcon'
                                            src={getContent(language, 'modal_img_show_icon')}
                                            className={styles.imgShowIcon}
                                            alt=""
                                            onClick={() => {
                                                this.openImg(getContent(language, 'modal_s13_w1_img_img_big'),
                                                    getContent('en', 'modal_s13_w1_img_sizes_mobile'))
                                            }}
                                        />

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s13_w1_img_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* modal_s1_w1_video */}
                        {modalType === 'modal_s1_w1_video' && (
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s1_w1_video_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s1_w1_video_subtitle')}
                                text={
                                    <p>{getContent(language, 'modal_s1_w1_video_content')}</p>
                                }
                                left={
                                    <img src={getContent(language, 'modal_s1_w1_video_img')} className={styles.img}
                                         alt=""
                                         onClick={() => {
                                             this.openVideo(getContent(language, 'modal_s1_w1_video_video'))
                                         }}/>
                                }
                            />
                        )}

                        {/* modal_s14_w1_video */}
                        {modalType === 'modal_s14_w1_video' && (
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s14_w1_video_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s14_w1_video_subtitle')}
                                text={
                                    <p>{getContent(language, 'modal_s14_w1_video_content')}</p>
                                }
                                left={
                                    <img src={getContent(language, 'modal_s14_w1_video_img')} className={styles.img}
                                         alt=""
                                         onClick={() => {
                                             this.openVideo(getContent(language, 'modal_s14_w1_video_video'))
                                         }}/>
                                }
                            />
                        )}

                        {/* modal_s14_w2_video */}
                        {modalType === 'modal_s14_w2_video' && (
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s14_w2_video_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s14_w2_video_subtitle')}
                                text={
                                    <p>{getContent(language, 'modal_s14_w2_video_content')}</p>
                                }
                                left={
                                    <img src={getContent(language, 'modal_s14_w2_video_img')} className={styles.img}
                                         alt=""
                                         onClick={() => {
                                             this.openVideo(getContent(language, 'modal_s14_w2_video_video'))
                                         }}/>
                                }
                            />
                        )}

                        {/* modal_s2_w1_imglist */}
                        {modalType === 'modal_s2_w1_imglist' &&
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s2_w1_imglist_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s2_w1_imglist_subtitle')}
                                text={
                                    <p>{this.state.imglistContent}</p>
                                }
                                left={
                                    <div
                                        className={styles.imageGallery}>
                                        <ImageGallery
                                            showPlayButton={false}
                                            showBullets={false}
                                            items={getContent(language, 'modal_s2_w1_imglist_imglist')}
                                            showIcon={getContent(language, 'modal_img_show_icon')}
                                            initSomething={() => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s2_w1_imglist_imglist')[0].thumbnail_big,
                                                    imglistContent: getContent(language, 'modal_s2_w1_imglist_content')[0],
                                                    imgShopUrl: getContent(language, 'modal_s2_w1_imglist_url')[0],
                                                    imgSizes: getContent('en', 'modal_s2_w1_imglist_sizes_mobile')[0],
                                                })
                                            }}
                                            onImgChange ={(index) => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s2_w1_imglist_imglist')[index].thumbnail_big,
                                                    imglistContent: getContent(language, 'modal_s2_w1_imglist_content')[index],
                                                    imgShopUrl: getContent(language, 'modal_s2_w1_imglist_url')[index],
                                                    imgSizes: getContent('en', 'modal_s2_w1_imglist_sizes_mobile')[index],
                                                })
                                            }}
                                            onMouseOver={() => {
                                                this.setState({
                                                    imgIconShow: true
                                                })
                                            }}
                                            onMouseLeave={() => {
                                                this.setState({
                                                    imgIconShow: false
                                                })
                                            }}
                                            onFullscreenButtonClick={() => {
                                                this.openImg(this.state.imgSrc,
                                                    this.state.imgSizes)
                                            }}
                                        />
                                    </div>
                                }
                                button={this.state.imgShopUrl ? <Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                                        href={this.state.imgShopUrl}>{getContent(language, 'modal_shop_btn')}</Button> : null}
                            />
                        }

                        {/* modal_s8_w1_imglist */}
                        {modalType === 'modal_s8_w1_imglist' &&
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s8_w1_imglist_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s8_w1_imglist_subtitle')}
                                text={
                                    <p>{this.state.imglistContent}</p>
                                }
                                left={
                                    <div
                                        className={styles.imageGallery}>
                                        <ImageGallery
                                            showPlayButton={false}
                                            showBullets={false}
                                            items={getContent(language, 'modal_s8_w1_imglist_imglist')}
                                            showIcon={getContent(language, 'modal_img_show_icon')}
                                            initSomething={() => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s8_w1_imglist_imglist')[0].thumbnail_big,
                                                    imglistContent: getContent(language, 'modal_s8_w1_imglist_content')[0],
                                                    imgSizes: getContent('en', 'modal_s8_w1_imglist_sizes_mobile')[0],
                                                })
                                            }}
                                            onImgChange ={(index) => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s8_w1_imglist_imglist')[index].thumbnail_big,
                                                    imgSizes: getContent('en', 'modal_s8_w1_imglist_sizes_mobile')[index],
                                                })
                                            }}
                                            onMouseOver={() => {
                                                this.setState({
                                                    imgIconShow: true
                                                })
                                            }}
                                            onMouseLeave={() => {
                                                this.setState({
                                                    imgIconShow: false
                                                })
                                            }}
                                            onFullscreenButtonClick={() => {
                                                this.openImg(this.state.imgSrc,
                                                    this.state.imgSizes)
                                            }}
                                        />
                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'modal_s8_w1_imglist_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        }

                        {/* modal_s11_w1_imglist */}
                        {modalType === 'modal_s11_w1_imglist' &&
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'modal_s11_w1_imglist_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'modal_s11_w1_imglist_subtitle')}
                                text={
                                    <p>{this.state.imglistContent}</p>
                                }
                                left={
                                    <div
                                        className={styles.imageGallery}>
                                        <ImageGallery
                                            showPlayButton={false}
                                            showBullets={false}
                                            items={getContent(language, 'modal_s11_w1_imglist_imglist')}
                                            showIcon={getContent(language, 'modal_img_show_icon')}
                                            initSomething={() => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s11_w1_imglist_imglist')[0].thumbnail_big,
                                                    imglistContent: getContent(language, 'modal_s11_w1_imglist_content')[0],
                                                    imgShopUrl: getContent(language, 'modal_s11_w1_imglist_url')[0],
                                                    imgSizes: getContent('en', 'modal_s11_w1_imglist_sizes_mobile')[0],
                                                })
                                            }}
                                            onImgChange ={(index) => {
                                                this.setState({
                                                    imgSrc: getContent(language, 'modal_s11_w1_imglist_imglist')[index].thumbnail_big,
                                                    imglistContent: getContent(language, 'modal_s11_w1_imglist_content')[index],
                                                    imgShopUrl: getContent(language, 'modal_s11_w1_imglist_url')[index],
                                                    imgSizes: getContent('en', 'modal_s11_w1_imglist_sizes_mobile')[index],
                                                })
                                            }}
                                            onMouseOver={() => {
                                                this.setState({
                                                    imgIconShow: true
                                                })
                                            }}
                                            onMouseLeave={() => {
                                                this.setState({
                                                    imgIconShow: false
                                                })
                                            }}
                                            onFullscreenButtonClick={() => {
                                                this.openImg(this.state.imgSrc,
                                                    this.state.imgSizes)
                                            }}
                                        />
                                    </div>
                                }
                                button={this.state.imgShopUrl ? <Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                                        href={this.state.imgShopUrl}>{getContent(language, 'modal_shop_btn')}</Button> : null}
                            />
                        }






                        {/* --------以下是备份---------*/}

                        {/* maskGif */}
                        {modalType === 'img' && (
                            <Layout
                                title={<p>{getContent(language, 'mask_modal_title')}</p>}
                                titleTips={getContent(language, 'mask_modal_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'mask_modal_content')}
                                    </p>
                                }
                                left={
                                    <div
                                        onMouseOver={() => {
                                            this.setState({
                                                imgIconShow: true
                                            })
                                        }}
                                        onMouseLeave={(e, e1) => {
                                            this.setState({
                                                imgIconShow: false
                                            })
                                        }}
                                    >
                                        <img
                                            src={getContent(language, 'mask_modal_img')}
                                            className={styles.img} alt=""
                                        />
                                        {this.state.imgIconShow ?
                                            <img
                                                name='imgShowIcon'
                                                src={getContent(language, 'modal_img_show_icon')}
                                                className={styles.imgShowIcon}
                                                alt=""
                                                onClick={() => {
                                                    this.openImg(getContent(language, 'mask_modal_img'))
                                                }}
                                            /> : null
                                        }

                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'mask_modal_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* 轮播 swiper */}
                        {modalType === 'swiper' && (
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'swiper_modal_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'swiper_modal_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'swiper_modal_content')}
                                    </p>
                                }
                                left={
                                    <div className={styles.img}>
                                        <Swiper list={this.swiperList}/>
                                        <div align="center" className={styles.guideText}>
                                            <img src={getContent(language, 'modal_swiper_img')}
                                                 className={styles.handImg}/>
                                            <p>{getContent(language, 'swiper_modal_tip')}</p>
                                        </div>
                                    </div>
                                }
                                button={<Button type="info" target='_blank' size='small' className={styles.btnShow}
                                                href={getContent(language, 'swiper_modal_url')}>{getContent(language, 'modal_shop_btn')}</Button>}
                            />
                        )}

                        {/* historyVideo */}
                        {modalType === 'video' && (
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'historyVideo_modal_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'historyVideo_modal_subtitle')}
                                text={
                                    <p>{getContent(language, 'historyVideo_modal_content')}</p>
                                }
                                left={
                                    <img src={getContent(language, 'historyVideo_modal_img')} className={styles.img}
                                         alt=""
                                         onClick={() => {
                                             this.openVideo(getContent(language, 'hisrotyVidro_modal_video'))
                                         }}/>
                                }
                                // button={<Button type="info" onClick={this.clickToShopOrg}>SHOP</Button>}
                            />
                        )}

                        {/* 脸部信息 */}
                        {modalType === 'face' &&
                            <FaceClick language={language} mobile={false}/>}
                        {/* PRODUCT BIBLE pdf */}
                        {modalType === 'pdf' && (
                            <Layout
                                title={<p>{getContent(language, 'pdf_modal_title')}</p>}
                                titleTips={getContent(language, 'pdf_modal_subtitle')}
                                text={
                                    <p>
                                        {getContent(language, 'pdf_modal_content')}
                                    </p>
                                }
                                left={
                                    <a href={getContent(language, 'pdf_modal_url')} target='_blank' rel="noreferrer">
                                        <img src={getContent(language, 'pdf_modal_img')} className={styles.img} alt=""/></a>
                                }
                                button={<Button size='small' className={styles.btnDownload}
                                                target='_blank' href={getContent(language, 'pdf_modal_url')}
                                                download={getContent(language, 'pdf_modal_url')}>
                                    {getContent(language, 'modal_download_btn')} </Button>}

                            />
                        )}

                        {/* 测试画廊 */}
                        {modalType === 'imgList' &&
                            <Layout
                                title={
                                    <p>
                                        {getContent(language, 'historyVideo_modal_title')}
                                    </p>
                                }
                                titleTips={getContent(language, 'historyVideo_modal_subtitle')}
                                text={
                                    <p>{getContent(language, 'historyVideo_modal_content')}</p>
                                }
                                left={
                                    <div
                                        className={styles.imageGallery}>
                                        <ImageGallery
                                            showPlayButton={false}
                                            showBullets={false}
                                            items={getContent(language, 'modal_s2_w1_imglist_imglist')}
                                            showIcon={ getContent(language, 'modal_img_show_icon') }
                                            onFullscreenButtonClick={() => {
                                                this.openImg(getContent(language, 'modal_test_imgs'))
                                            }}
                                            onImgChange ={(imgSrc) => {
                                                this.setState({
                                                    imgSrc: imgSrc
                                                })
                                            }}
                                            onMouseOver={() => {
                                                this.setState({
                                                    imgIconShow: true
                                                })
                                            }}
                                            onMouseLeave={(e, e1) => {
                                                this.setState({
                                                    imgIconShow: false
                                                })
                                            }}
                                        />
                                    </div>
                                }
                            />
                        }

                    </div>

                    <div className={styles.footer}>©2022 CEMÔY</div>
                </Modal>
                {/* 背景 */}
                <Modal
                    visible={videoShow || imgShow}
                    className={styles.videoBackground}
                    footer={null}
                    onCancel={null}
                    closable={false}
                >
                    <div id='videoBackground' style={{
                        position: 'absolute',
                        top: '0',
                        display: 'block',
                        width: '100%',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 20, 37, 0.8)',
                        zIndex: '1000'
                    }}
                         onClick={this.closeVideo}></div>
                </Modal>
                <VideoModal videoShow={videoShow} language={language}
                            videoSrc={videoSrc} onClose={this.closeVideo}></VideoModal>
                <ImgModal show={imgShow} language={language}
                          src={imgSrc} onClose={this.closeImg} imgSizes={imgSizes}></ImgModal>
                {/* <Modal
          visible={videoShow}
          className={styles.videoBackground}
          footer={null}
          closable={false}
          maskStyle={{
            background: 'none',
          }}
        />
      <div className={styles.videoBackground}></div> */}
            </>
        )
    }
}
